export default function dateTimeFormat(dateString: Date, options?: any): string {
  return new global.Intl.DateTimeFormat('en-us', options).format(dateString);
}
